module.exports = __webpack_public_path__ + "static/media/logoDoctorPlan.977b24eb.png";